import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Form, message, notification } from "antd";
import { Col, Row } from "react-bootstrap";
import UISectionHeading from "../../../common/UISectionHeading/UISectionHeading";
import { connect } from "react-redux";
import UiButton from "../../../common/UiButton/UiButton";
import { v4 as uuidv4 } from "uuid";
import UploadDoc from "./UploadDoc";
import "./style.css";
import { Link } from "react-router-dom";
import bactolist from "../../../images/back.png";

import {
  getLeadDocumentMastersList,
  getAllLeadDoc,
  proceedLeadDoc,
} from "../../../redux/AddLeadDocument/action";
import { Lead_Service_URL } from "../../../redux/Url";
import useSession from "../../CustomLogout/useSession";

const AddLeadDocument = (props) => {
  const handleSessionExpired = useSession();

  const dynamicKey = uuidv4();
  const location = useLocation();
  const id = location?.state?.leadId;

  const [form] = Form.useForm();
  const history = useNavigate();
  const temp = useLocation();
  const leadDisable = temp?.state?.leadDisable;

  const { leadId } = props;
  const [getLeadEduDocList, setGetLeadEduDocList] = useState();
  const [getLeadBankDocList, setGetLeadBankDocList] = useState();
  const [getLeadIncomeDocList, setGetLeadIncomeDocList] = useState();
  const [coApplicants, setCoApplicants] = useState([]);

  const [getLeadKycDocList, setGetLeadKycDocList] = useState();
  const [getLeadDocMaster, setGetLeadDocMaster] = useState();
  const [btnDisable, setBtnDisable] = useState(false);
  const [uploadDocList, setUploadDocList] = useState();
  const [viewDocument, setViewDocument] = useState([]);

  const [key, setKey] = useState(1);

  useEffect(() => {
    props
      .getLeadDocumentMastersList({
        access_token: props.auth?.accessToken?.access_token,
        leadId: id,
      })
      .then((res) => {
        if (res?.status === 200) {
          setGetLeadEduDocList(res?.data?.leadEducationDocumentsList);
          setGetLeadKycDocList(res?.data?.leadKycDocumentsList);
          setGetLeadBankDocList(res?.data?.leadBankDocumentsList);
          setGetLeadIncomeDocList(res?.data?.leadIncomeDocumentsList);
          const coApplicantsArray = [];
          for (const key in res?.data) {
            if (key.startsWith("CO_APPLICANT")) {
              coApplicantsArray.push(res?.data[key]);
            }
          }

          setCoApplicants(coApplicantsArray);

          setGetLeadDocMaster(res?.data);
          setKey(2);
          window.scrollTo(0, 0);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
    getViewBankDocumentAPI();
  }, []);
  const getViewBankDocumentAPI = () => {
    props
      .getAllLeadDoc({
        access_token: props.auth?.accessToken?.access_token,
        leadId: id,
      })
      .then((res) => {
        if (res?.status === 200) {
          const data = res?.data?.dtoList;
          setUploadDocList(data?.docTypeId);
          setKey(4);
          if (data) {
            setViewDocument([
              ...data?.map((el) => {
                return {
                  url: el?.documentLink,
                  status: "done",
                  uid: el?.docTypeId,
                  name: el?.fileName,
                };
              }),
            ]);
          }
          // setGetLeadKycDocList(res?.data?.leadKycDocumentsList);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };
  const onChangedocs = (info) => {
    // console.log(info);
  };
  const handleSubmitLeadDoc = () => {
    props
      .proceedLeadDoc({
        access_token: props.auth?.accessToken?.access_token,
        leadId: id,
      })

      .then((res) => {
        if (res && res.status === 200) {
          message.success("Lead Doc Added Successfully ");
          history(`/leadManagementDashboard/leadManagement`, {
            state: { leadDocument: true },
          });
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };
  const sanitizeSectionHeading = (heading) => {
    // Replace any non-alphanumeric characters with an empty string
    return heading.replace(/[^a-zA-Z0-9]/g, "");
  };
  return (
    <div>
      <Form
        autoComplete="off"
        className="leaddeatils"
        name="leaddoc"
        form={form}
        onFinish={handleSubmitLeadDoc}
      >
        <div class="backlist">
          <Link
            className="ListItem"
            to="/leadManagementDashboard/leadManagement"
          >
            <img src={bactolist} alt="" />
          </Link>
        </div>
        <Row className="leadformdetails">
          <Col md={12}>
            <div className="subheading">
              <UISectionHeading secHeading="Lead Details " />
            </div>
            <div className="inner-text-lead">
              <h4>
                <span style={{ marginRight: "8px", fontWeight: "600" }}>
                  Lead Full Name:
                </span>
                {getLeadDocMaster?.leadFullName
                  ? getLeadDocMaster?.leadFullName
                  : "------"}
              </h4>
            </div>
            <div className="inner-text-lead">
              <h4>
                <span style={{ marginRight: "8px", fontWeight: "600" }}>
                  Mobile No:
                </span>
                {getLeadDocMaster?.leadFullName
                  ? getLeadDocMaster?.leadMobile
                  : "------"}
              </h4>
            </div>
          </Col>
        </Row>
        <hr></hr>
        <div className="container-main">
          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="content-Section">
              <Col md={4} className="leftsidecontent">
                <div className="subheading">
                  <UISectionHeading secHeading="Student KYC Documents" />
                </div>
              </Col>
              <Col md={8} className="lead-field-section">
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="Documents-sect"
                  >
                    {getLeadKycDocList &&
                      getLeadKycDocList.map((item, index) => (
                        <Col
                          md={12}
                          className="Documents-sect-inner"
                          key={index}
                        >
                          <div className="content-inner-doc">
                            <Col md={4} className="text-section-doc">
                              <h4>{item.leadDocumentTypeName}</h4>
                            </Col>

                            <Col md="auto" className="btn-section-doc">
                              <UploadDoc
                                key={dynamicKey}
                                listType="text"
                                className="selected-optdoc new mb-0"
                                disabled={leadDisable}
                                showUploadList={{
                                  showRemoveIcon: false,
                                }}
                                progress={{
                                  showInfo: false,
                                  showProgress: false,
                                }}
                                accept=".pdf,.png,.jpg"
                                onChange={onChangedocs}
                                dmsDocTypeName={item}
                                endPoint={`${Lead_Service_URL}/uploadLeadDoc?&leadId=${id}&docTypeId=${item.dmsDocTypeId}`}
                                defaultFileList={viewDocument?.filter((el) => {
                                  return el?.uid == item.dmsDocTypeId;
                                })}
                                refreshDocsAPI={getViewBankDocumentAPI}
                                // extraText="Physical"
                              />
                            </Col>
                          </div>
                          <hr></hr>
                        </Col>
                      ))}
                  </Col>
                </Row>
              </Col>
            </Col>
          </Row>

          <hr></hr>
          <br></br>

          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="content-Section">
              <Col md={4} className="leftsidecontent">
                <div className="subheading">
                  <UISectionHeading secHeading="Student Education Details" />
                </div>
              </Col>
              <Col md={8} className="lead-field-section">
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="Documents-sect"
                  >
                    {getLeadEduDocList &&
                      getLeadEduDocList.map((item, index) => (
                        <Col
                          md={12}
                          className="Documents-sect-inner"
                          key={index}
                        >
                          <div className="content-inner-doc">
                            <Col md={4} className="text-section-doc">
                              <h4>{item.leadDocumentTypeName}</h4>
                            </Col>

                            <Col md="auto" className="btn-section-doc">
                              <UploadDoc
                                key={dynamicKey}
                                listType="text"
                                disabled={leadDisable}
                                className="selected-optdoc new mb-0"
                                showUploadList={{
                                  showRemoveIcon: false,
                                }}
                                progress={{
                                  strokeWidth: 1,
                                  showInfo: false,
                                }}
                                accept=".pdf,.png,.jpg"
                                onChange={onChangedocs}
                                dmsDocTypeName={item}
                                endPoint={`${Lead_Service_URL}/uploadLeadDoc?&leadId=${id}&docTypeId=${item.dmsDocTypeId}`}
                                defaultFileList={viewDocument?.filter((el) => {
                                  return el?.uid == item.dmsDocTypeId;
                                })}
                                refreshDocsAPI={getViewBankDocumentAPI}
                                // extraText="Physical"
                              />
                            </Col>
                          </div>
                          <hr></hr>
                        </Col>
                      ))}
                  </Col>
                </Row>
              </Col>
            </Col>
          </Row>
          <hr></hr>
          <br></br>

          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="content-Section">
              <Col md={4} className="leftsidecontent">
                <div className="subheading">
                  <UISectionHeading secHeading="Student Bank Details" />
                </div>
              </Col>
              <Col md={8} className="lead-field-section">
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="Documents-sect"
                  >
                    {getLeadBankDocList &&
                      getLeadBankDocList.map((item, index) => (
                        <Col
                          md={12}
                          className="Documents-sect-inner"
                          key={index}
                        >
                          <div className="content-inner-doc">
                            <Col md={4} className="text-section-doc">
                              <h4>{item.leadDocumentTypeName}</h4>
                            </Col>

                            <Col md="auto" className="btn-section-doc">
                              <UploadDoc
                                key={dynamicKey}
                                listType="text"
                                disabled={leadDisable}
                                className="selected-optdoc new mb-0"
                                showUploadList={{
                                  showRemoveIcon: false,
                                }}
                                progress={{
                                  strokeWidth: 1,
                                  showInfo: false,
                                }}
                                accept=".pdf,.png,.jpg"
                                onChange={onChangedocs}
                                dmsDocTypeName={item}
                                endPoint={`${Lead_Service_URL}/uploadLeadDoc?&leadId=${id}&docTypeId=${item.dmsDocTypeId}`}
                                defaultFileList={viewDocument?.filter((el) => {
                                  return el?.uid == item.dmsDocTypeId;
                                })}
                                refreshDocsAPI={getViewBankDocumentAPI}
                                // extraText="Physical"
                              />
                            </Col>
                          </div>
                          <hr></hr>
                        </Col>
                      ))}
                  </Col>
                </Row>
              </Col>
            </Col>
          </Row>
          <hr></hr>
          <br></br>

          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="content-Section">
              <Col md={4} className="leftsidecontent">
                <div className="subheading">
                  <UISectionHeading secHeading="Student Income Details" />
                </div>
              </Col>
              <Col md={8} className="lead-field-section">
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="Documents-sect"
                  >
                    {getLeadIncomeDocList &&
                      getLeadIncomeDocList.map((item, index) => (
                        <Col
                          md={12}
                          className="Documents-sect-inner"
                          key={index}
                        >
                          <div className="content-inner-doc">
                            <Col md={4} className="text-section-doc">
                              <h4>{item.leadDocumentTypeName}</h4>
                            </Col>

                            <Col md="auto" className="btn-section-doc">
                              <UploadDoc
                                key={dynamicKey}
                                listType="text"
                                disabled={leadDisable}
                                className="selected-optdoc new mb-0"
                                showUploadList={{
                                  showRemoveIcon: false,
                                }}
                                progress={{
                                  strokeWidth: 1,
                                  showInfo: false,
                                }}
                                accept=".pdf,.png,.jpg"
                                onChange={onChangedocs}
                                dmsDocTypeName={item}
                                endPoint={`${Lead_Service_URL}/uploadLeadDoc?&leadId=${id}&docTypeId=${item.dmsDocTypeId}`}
                                defaultFileList={viewDocument?.filter((el) => {
                                  return el?.uid == item.dmsDocTypeId;
                                })}
                                refreshDocsAPI={getViewBankDocumentAPI}
                                // extraText="Physical"
                              />
                            </Col>
                          </div>
                          <hr></hr>
                        </Col>
                      ))}
                  </Col>
                </Row>
              </Col>
            </Col>
          </Row>
          <hr></hr>
          <br></br>
          {coApplicants?.map((coApplicant, index) => (
            <div key={index}>
              {Object.keys(coApplicant).map((key) => {
                let currentArray = coApplicant[key];
                if (!Array.isArray(currentArray)) {
                  currentArray = [currentArray];
                }

                return (
                  <>
                    <Row key={key}>
                      <Col
                        lg={12}
                        xs={12}
                        md={12}
                        sm={12}
                        className="content-Section"
                      >
                        <Col md={4} className="leftsidecontent">
                          <div className="subheading coAppHeading">
                            <UISectionHeading
                              secHeading={currentArray[0]?.sectionDisplayName}
                            />
                          </div>
                        </Col>

                        <Col md={8} className="lead-field-section">
                          <Row>
                            {currentArray.map((item, itemIndex) => (
                              <Col
                                lg={12}
                                xs={12}
                                md={12}
                                sm={12}
                                className="Documents-sect"
                                key={itemIndex}
                              >
                                <Col md={12} className="Documents-sect-inner">
                                  <div className="content-inner-doc">
                                    <Col md={4} className="text-section-doc">
                                      <h4>{item.leadDocumentTypeName}</h4>
                                    </Col>

                                    <Col md="auto" className="btn-section-doc">
                                      <UploadDoc
                                        key={dynamicKey}
                                        listType="text"
                                        disabled={leadDisable}
                                        className="selected-optdoc new mb-0"
                                        showUploadList={{
                                          showRemoveIcon: false,
                                        }}
                                        progress={{
                                          strokeWidth: 1,
                                          showInfo: false,
                                        }}
                                        accept=".pdf,.png,.jpg"
                                        onChange={onChangedocs}
                                        dmsDocTypeName={item}
                                        endPoint={`${Lead_Service_URL}/uploadLeadDoc?&leadId=${id}&docTypeId=${item.dmsDocTypeId}`}
                                        defaultFileList={viewDocument?.filter(
                                          (el) => el?.uid == item.dmsDocTypeId
                                        )}
                                        refreshDocsAPI={getViewBankDocumentAPI}
                                      />
                                    </Col>
                                  </div>
                                  <hr />
                                </Col>
                              </Col>
                            ))}
                          </Row>
                        </Col>
                      </Col>
                    </Row>
                    <hr></hr>
                    <br></br>
                  </>
                );
              })}
            </div>
          ))}

          <br></br>
          <br></br>

          <Row>
            <Col md={4}></Col>
            <Col md={8}>
              {" "}
              <UiButton
                style={{ float: "right" }}
                type="submit"
                title="Submit"
              />
            </Col>
          </Row>
        </div>
      </Form>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getLeadDocumentMastersList: (data) =>
      dispatch(getLeadDocumentMastersList(data)),
    getAllLeadDoc: (data) => dispatch(getAllLeadDoc(data)),
    proceedLeadDoc: (data) => dispatch(proceedLeadDoc(data)),
  };
};
const mapStateToProps = (state) => {
  return {
    documentsMaster: state.documentsMaster,
    auth: state.auth,
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    leadId: state.AddLead.saveAddLead.Id,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddLeadDocument);
// export default AddLeadDocument;
